import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UpdatePortChargesPaymentsService } from 'src/app/services/transactions/update-port-charges-payments.service';
import { GlobalService } from 'src/app/services/shared/global.service';

@Component({
  selector: 'app-update-port-charges-payments',
  templateUrl: './update-port-charges-payments.component.html',
  styleUrls: ['./update-port-charges-payments.component.css']
})
export class UpdatePortChargesPaymentsComponent implements OnInit{
  public isLoading: boolean = false;
  public errorMessage: string | null = null;
  form!: FormGroup;
  submitted: boolean = false;
  billsOfLading: any[] = [];
  selectedBL!: string;
  currPortChargesPayments: any[] = [];

  constructor(
    private globalService: GlobalService,
    private formBuilder: FormBuilder,
    private updatePortChargesPaymentsService: UpdatePortChargesPaymentsService,
  ){
    this.form = this.formBuilder.group({
      amount:['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.isLoading=true;
    this.fetchBLs();
  }

  fetchBLs():void {
    this.updatePortChargesPaymentsService.getBLs().subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.isLoading = false;
          this.billsOfLading = response.data
        }else{
          this.isLoading = false;
          this.globalService.setGlobalErrorMessage(response.message);
        }
      },
      error: (error) => {
        this.isLoading = false;
        this.globalService.setGlobalErrorMessage(error);
      }
    });
  }

  onSelectChange(blNo: string) {
    if(blNo!=null || blNo!=undefined || blNo!=''){
      this.isLoading = true;
    this.fetchUnitsByBL(blNo);
    }
  }

  fetchUnitsByBL(blNo: string):void {
    this.updatePortChargesPaymentsService.getUnits(blNo).subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.isLoading = false;
          this.currPortChargesPayments = response.data
        }else{
          this.isLoading = false;
          this.globalService.setGlobalErrorMessage(response.message);
        }
      },
      error: (error) => {
        this.isLoading = false;
        this.globalService.setGlobalErrorMessage(error);
      }
    });
  }

  handleSubmit() {
    this.submitted = true;
    this.isLoading=true;

    if(this.form.valid) {
      if(this.selectedBL==null || this.selectedBL==undefined){
        this.errorMessage="Please select BL to proceed!";
        this.isLoading=false;
      }else{
        this.updatePortChargesPaymentsService.updatePortChargesPayments(this.selectedBL,this.form.value.amount)
        .subscribe({
          next: (response) => {
            if(response.status==='success'){
              this.submitted = false;
              this.errorMessage=null;
              this.globalService.setGlobalSuccessMessage(response.message);
              //Reload BLs
              this.fetchUnitsByBL(this.selectedBL);
            }else{
              this.errorMessage=response.message;
              this.submitted = false;
              this.isLoading=false;
            }
          },
          error: (error) => {
            this.errorMessage="Oops! A problem was encountered while processing your request. Please try again or consult your system administrator.";
            this.submitted = false;
            this.isLoading=false;
          }
        });
      }
    }else{
      this.isLoading=false;
    }
  }
}
